module.exports = __webpack_public_path__ + "static/media/Datas_A_COMMERCE.25e6c70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Datas_A_COMMERCE.png
// module id = 241
// module chunks = 0